import(/* webpackMode: "eager" */ "C:\\Users\\Avenir-IT\\Documents\\Pizza App\\pizza-app-fe\\src\\components\\pages\\itemview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Avenir-IT\\Documents\\Pizza App\\pizza-app-fe\\src\\components\\preloader.tsx");
